import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Video, Phone } from "lucide-react";

export const VideoPortal = () => {
  return (
    <Card className="p-4">
      <div className="flex flex-col items-center justify-center h-[400px] space-y-4">
        <h3 className="text-lg font-semibold">Start a Video Call</h3>
        <div className="flex gap-4">
          <Button variant="outline" size="lg">
            <Video className="w-4 h-4 mr-2" />
            Video Call
          </Button>
          <Button variant="outline" size="lg">
            <Phone className="w-4 h-4 mr-2" />
            Audio Call
          </Button>
        </div>
      </div>
    </Card>
  );
};